import { render, staticRenderFns } from "./GraphsKamsBoss.vue?vue&type=template&id=89209188"
import script from "./GraphsKamsBoss.vue?vue&type=script&lang=js"
export * from "./GraphsKamsBoss.vue?vue&type=script&lang=js"
import style0 from "./GraphsKamsBoss.vue?vue&type=style&index=0&id=89209188&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports